import Chart from 'chart.js/auto'

document.addEventListener("DOMContentLoaded", function () {
	// Fetch the chartData from the HTML
	const chartData = JSON.parse(document.getElementById('chart-data').textContent);

	// Ensure there's always at least one chart container
	const ctx = document.getElementById("combined-chart").getContext('2d');

	// Prepare datasets for the combined chart
	const combinedDatasets = chartData.map(function (chart) {
		return {
			label: `Offer: ${chart.offer}, Affiliate: ${chart.affiliate}, Source: ${chart.source_id}`,
			data: chart.data.length > 0 ? chart.data : [0],  // Use placeholder data if empty
			borderColor: getRandomColor(), // Get a random color for each dataset
			fill: false,
			borderWidth: 2,
			pointBackgroundColor: function (context) {
				return chart.significant_drops[context.dataIndex] ? 'rgba(255, 99, 132, 1)' : 'rgba(75, 192, 192, 1)';
			},
			tension: 0.1
		};
	});

	// Use the labels from the first dataset if available, or a placeholder
	const combinedLabels = window.chartData.length > 0 ? window.chartData[0].labels : ['No Data Available'];

	// Define the chart configuration
	const chartConfig = {
		type: 'line',
		data: {
			labels: combinedLabels,
			datasets: combinedDatasets
		},
		options: {
			responsive: true,
			scales: {
				x: {
					title: {
						display: true,
						text: 'Date'
					}
				},
				y: {
					title: {
						display: true,
						text: 'Average RPM'
					},
					beginAtZero: true
				}
			}
		}
	};

	// Create the chart
	new Chart(ctx, chartConfig);

	// Helper function to generate a random color for each line
	function getRandomColor() {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (var i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}
});
